import React, { useState } from "react";
import { useParams } from "react-router";
import { Alert } from "antd";
import { useTicketDetails } from "../../hooks/useTicketDetails";
import MergedTickets from "../../components/ModalLayout/components/MergedTickets";
import Remarks from "../../components/ModalLayout/components/Remarks";
import AssigneeSection from "./AssigneeSection";
import LeftSection from "./LeftSection";
import "./style.scss";
import LeftSectionSkeleton from "./LeftSection/LeftSectionSkeleton";
import AssigneeSectionSkeleton from "./AssigneeSection/AssigneeSectionSkeleton";

const TicketDetails: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMergedTicketsOpen, setIsMergedTicketsOpen] = useState(false);
  const [ticketType, setTicketType] = useState<"None" | "Primary" | "Merged">(
    "Primary"
  );
  const [selectedRemark, setSelectedRemark] = useState<string>("");

  const { id } = useParams();
  const { data, isLoading, error, refetch } = useTicketDetails(id);

  const handleSwitchToPrimary = () => setTicketType("Primary");

  // if (isLoading) {
  //   return (
  //     <div className="ticket-details-frame flex gap-4 p-4">
  //       <Skeleton
  //         active
  //         paragraph={{ rows: 15 }}
  //         title={{ width: "60%" }}
  //         className="left-section-skeleton"
  //       />
  //       <Skeleton
  //         active
  //         paragraph={{ rows: 12 }}
  //         title={{ width: "50%" }}
  //         className="right-section-skeleton"
  //       />
  //     </div>
  //   );
  // }

  if (error)
    return <Alert type="error" message="Failed to load ticket details" />;

  return (
    <>
      <div className="ticket-details-frame flex">
        {isLoading || !data ? (
          <div className="flex mt-20 w-full ">
            <LeftSectionSkeleton />
            <AssigneeSectionSkeleton />
          </div>
        ) : (
          <>
            <LeftSection
              refetchTickets={refetch}
              ticketType={ticketType}
              onSwitchToPrimary={handleSwitchToPrimary}
              ticketData={data.ticket}
              accountData={data.account}
              pikitupServices={data.pikitupServices}
              pikitupMeta={data.pikitupMeta}
            />
            {data && (
              <AssigneeSection
                refetchTickets={refetch}
                ticketType={ticketType}
                onOpenRemarks={(comment: any) => {
                  setSelectedRemark(comment);
                  setIsOpen(true);
                }}
                onOpenMergedTickets={() => setIsMergedTicketsOpen(true)}
                onSwitchToPrimary={handleSwitchToPrimary}
                ticketData={data?.ticket}
              />
            )}
          </>
        )}
      </div>

      <Remarks
        title="Remarks"
        open={isOpen}
        remarkText={selectedRemark}
        onClose={() => setIsOpen(false)}
        onConfirm={() => setIsOpen(false)}
      />

      <MergedTickets
        data={data?.related_tickets || []}
        title="Merged tickets"
        open={isMergedTicketsOpen}
        onClose={() => setIsMergedTicketsOpen(false)}
        onConfirm={() => setIsMergedTicketsOpen(false)}
        onSwitchToMerged={() => {
          setTicketType("Merged");
          setIsMergedTicketsOpen(false);
        }}
      />
    </>
  );
};

export default TicketDetails;
